import request from '@/utils/request'

const _Prefix = '/community'

// 查询小区信息列表
export function communityList (query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}

// 查询小区信息详细
export function getCommunity (id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增小区信息
export function addCommunity (data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改小区信息
export function updateCommunity (data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除小区信息
export function delCommunity (ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}
